export default "__VITE_ASSET__CRPKpaGF__"